<template>
  <div>
    <v-dialog scrollable v-model="value" max-width="800" persistent>
      <v-card>
        <v-card-text>
          <h3 class="title">
            กรุณาตรวจสอบขนส่งอีกครั้งก่อนยืนยันการทำรายการ ({{ orders.length }} รายการ)
          </h3>
          <template v-for="(order, index) in orders">
            <v-layout wrap :key="`sokochan_${order.id}`">
              <v-flex xs12 sm3 class="py-2">
                <v-chip small color="blue" class="white--text" disabled
                  >Order No.: {{ order.id }}</v-chip
                >
              </v-flex>
              <v-flex xs12 sm5 class="pa-2">
                {{ order.nameaddress }}
              </v-flex>
              <v-flex xs12 sm4 class="text-xs-right pa-2"
                >{{ $t(order.shippingtype) }}
                <template v-if="order.shippingtype == 'cod_charge'">
                  <v-select
                    name="customshippingtype"
                    data-vv-as="ขนส่ง"
                    single-line
                    v-model="order.customshippingtype"
                    :items="shippingOptions"
                    outline
                    placeholder="เลือกขนส่ง"
                    v-validate="'required'"
                    :hide-details="!errors.has('customshippingtype')"
                    :error-messages="errors.first('customshippingtype')"
                  ></v-select>
                </template>
              </v-flex>
            </v-layout>
            <v-divider v-if="index != orders.length - 1" :key="`divider_${order.id}`" />
          </template>
          <div class="text-xs-center">
            <v-btn color="grey" outline :loading="loading" @click="close">{{ $t('Back') }}</v-btn>
            <v-btn color="primary" depressed @click="confirmSokochan" :loading="loading">{{
              $t('Next')
            }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'orders'],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      addresses: 'getShippingAddress'
    })
  },
  data() {
    return {
      loading: false,
      shippingOptions: [
        { value: 'normal_charge', text: '(COD) ' + this.$t('normal_charge') },
        { value: 'kerry_charge', text: '(COD) ' + this.$t('kerry_charge') },
        {
          value: 'kerry1d_charge',
          text: '(COD) ' + this.$t('kerry1d_charge')
        },
        {
          value: 'kerry2d_charge',
          text: '(COD) ' + this.$t('kerry2d_charge')
        }
      ]
    }
  },
  methods: {
    close() {
      this.step = 1
      this.$emit('input', false)
    },
    async confirmSokochan() {
      const vm = this
      var result = await vm.$validator.validateAll()

      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        await vm.$swal({
          title: 'ข้อมูลไม่ครบถ้วนหรือไม่สามารถจัดส่งบางออเดอร์ได้',
          type: 'error',
          confirmButtonText: vm.$t('Confirm')
        })
        return false
      }
      vm.loading = true
      try {
        let promises = vm.orders.map(order => {
          // เปลี่ยนสถานะแล้วส่ง order ให้ sokochan

          let body = {
            orderid: order.id
          }

          if (order.customshippingtype) body.new_shipping_type = order.customshippingtype

          return api.post_sokochan_create_new_order({
            body: body,
            params: {
              pageid: vm.selectedBot.pageid
            }
          })
        })

        let responses = await Promise.all(promises)
        if (responses.length > 0) {
          responses.map(item => {
            if (item.status === 400) {
              vm.$swal.fire({
                title: 'ไม่สามารถส่งกับ SOKOCHAN ได้เนื่องจาก',
                text: item.data.result.error,
                type: 'error',
                confirmButtonText: vm.$t('Confirm')
              })
              vm.loading = false
            }
          })
        }

        try {
          let updateorders = responses
            .map(el => {
              if (el.success && el.result && el.result.orderid) return el.result.orderid
              return false
            })
            .filter(el => el !== false)
          if (updateorders.length > 0)
            vm.$emit('updateStatus', {
              orders: updateorders,
              oncomplete: () => {
                vm.close()
                window.location.reload()
                vm.loading = false
              }
            })
        } catch (error) {
          console.log(error)
          let text = ''
          vm.$swal
            .fire({
              title: 'ส่งข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง',
              text: text,
              type: 'error',
              confirmButtonText: vm.$t('Confirm')
            })
            .then(result => {
              vm.close()
              window.location.reload()
              vm.loading = false
            })
        }
      } catch (error) {
        console.log(error)
        let text = ''
        vm.$swal
          .fire({
            title: 'ส่งข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง',
            text: text,
            type: 'error',
            confirmButtonText: vm.$t('Confirm')
          })
          .then(result => {
            vm.close()
            window.location.reload()
            vm.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SokochanShipping.vue